<template lang="pug">
div
  //- Mobile: horizontal scrollable tabs
  div(v-if="$vuetify.breakpoint.mobile")
    div.overflow-x-auto
      div.d-flex.align-center.justify-start(style="width: max-content;")
        template(v-for="menu in sideMenu")
          div(:key="menu.id")
            router-link(:to="menu.to" v-slot="{ href, navigate }" custom)
              div
                .px-4.py-2
                  a.text-sm.font-semibold.capitalize.no-underline(:href="href" @click="navigate" :class="isMenuActive(menu) ? '' : 'neutral500--text'") {{ menu.title }}
                .bar-active(v-if="isMenuActive(menu)")
    div.neutral300(:class="isMobileScreen ? 'mobile-screen' : ''")
      .pa-5
        router-view

  //- Desktop: side-by-side layout
  .d-flex(v-else)
    //- Left panel navigation
    .left-panel.pa-8(style="width: 280px; min-width: 280px;")
      div(v-for="menu in sideMenu" :key="menu.id")
        router-link(:to="menu.to" v-slot="{ navigate }" custom)
          .font-semibold.text-md.px-3.py-2.mb-2(
            @click="navigate"
            :class="isMenuActive(menu) ? 'selected-bg round-sm' : 'cursor-pointer neutral500--text'"
          ) {{ menu.title }}

    //- Right panel (main content)
    .flex-grow-1(style="min-width: 0;")
      router-view
</template>

<script>
export default {
  name: 'HQInventoryLayout',
  data() {
    return {
      sideMenu: [
        { id: 'inventory', to: '/admin/hq/inventory', title: 'Inventory', exact: true },
        { id: 'services', to: '/admin/hq/inventory/services', title: 'Services' },
        { id: 'packages', to: '/admin/hq/inventory/packages', title: 'Packages' },
        { id: 'stock-take', to: '/admin/hq/inventory/stock-take', title: 'Stock take' },
        { id: 'branches-warehouses', to: '/admin/hq/inventory/branches-warehouses', title: 'Branches & Warehouses' },
        { id: 'storage-locations', to: '/admin/hq/inventory/storage-locations', title: 'Storage locations' },
        { id: 'list', to: '/admin/hq/inventory/list', title: 'List' }
      ]
    }
  },
  mounted() {
    // Redirect to first menu item if on base inventory path
    const currentPath = this.$router.currentRoute.path
    if (currentPath === '/admin/hq/inventory') {
      // Stay on inventory home, no redirect needed
    }
  },
  computed: {
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    isMenuActive(menu) {
      const currentPath = this.$route.path
      if (menu.exact) return currentPath === menu.to
      return currentPath.startsWith(menu.to)
    }
  }
}
</script>

<style lang="scss" scoped>
.overflow-x-auto {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
}

.bar-active {
  height: 2px;
  width: 100%;
  margin: auto;
  margin-top: -2px;
  background-color: #333;
}

.mobile-screen {
  min-height: calc(100dvh - 90px);
}

.left-panel {
  position: sticky;
  top: 72px;
  align-self: flex-start;
  max-height: calc(100vh - 72px);
  overflow-y: auto;
}
</style>
